module.exports = {
  en: {
    'HRES81X': {
      '10': 'ใบแจ้งการจ่ายเงินได้',
      '20': 'รหัสพนักงาน',
      '30': 'สำหรับงวดที่',
      '40': 'เดือน/ปี'
    },
    'HRES81XC1': {
      '10': 'งวดที่',
      '15': 'เดือน / ปี',
      '20': 'รายละเอียดการจ่ายเงินเดือน',
      '25': 'เลขที่บัญชี',
      '30': 'วันที่จ่าย',
      '35': 'รายได้',
      '40': 'ส่วนหัก',
      '45': 'รวมรายได้',
      '50': 'สุทธิ',
      '55': 'เงินสุทธิตามสกุลเงิน',
      '60': 'รายได้สะสม',
      '65': 'เงินสะสมกองทุนสำรองเลี้ยงชีพ',
      '70': 'รวมค่าใช้จ่าย',
      '75': 'ภาษีสะสม',
      '80': 'เงินสะสมประกันสังคม'
    },
    'HRES81XCM': {
      '10': 'รหัสพนักงาน',
      '15': 'ตำแหน่งงาน',
      '16': 'แผนก',
      '17': 'ช่วงเวลาจ่ายเงินเดือน',
      '18': 'ช่วงระยะเวลาเช็คเวลาทำงาน',
      '19': 'ฐานเงินเดือน',
      '20': 'ชื่อ',
      '30': 'งวดที่',
      '40': 'เดือน',
      '50': 'ปี',
      '60': 'เลขที่บัญชี',
      '70': 'ธนาคาร',
      '80': 'วันที่จ่าย (Payment Date)',
      '90': 'รายได้ (Incomes)',
      '100': 'บาท',
      '110': 'ส่วนหัก (Deductions)',
      '120': 'บาท',
      '130': 'รายละเอียด อื่นๆ (Others)',
      '140': 'สิทธิพักร้อนคงเหลือ (VL)',
      '150': 'จำนวนวันทำงาน',
      '160': 'ยอดสะสมประจำปี (Yearly Sum)',
      '170': 'รายได้สะสม (Incomes)',
      '180': 'ภาษีสะสม (Tax)',
      '190': 'เงินสะสมกองทุน (PF)',
      '200': 'เงินประกันสังคมสะสม (SI)',
      '210': 'รวมรายได้ (Total Incomes)',
      '220': 'รวมเงินหัก (Total Deductions)',
      '230': 'จ่ายงวดนี้',
      '240': 'เงินได้สุทธิ (Net Receipt)',
      '245': 'อัตราค่าจ้าง (Salary)',
      '250': 'O.T',
      '260': 'ชม.',
      '270': 'วัน',
      '280': 'อื่น ๆ'
    },
    'HRPY55X': {
      '10': 'งวดที่',
      '20': 'เดือน',
      '30': 'ปี',
      '40': 'รหัสพนักงาน',
      '50': 'หรือรหัสหน่วยงาน',
      '60': 'กลุ่มการจ่ายเงินเดือน',
      '70': 'มาตรฐาน',
      '80': 'Preprinted form',
      '90': 'รูปแบบการพิมพ์',
      '100': 'แบบฟอร์ม Pay Slip',
      '110': 'รหัส',
      '120': 'รายละเอียดการจ่ายเงินเดือน',
      '130': 'ACC NO',
      '140': 'ธนาคาร',
      '150': 'วันที่จ่าย',
      '160': 'รายได้ (Income)',
      '170': 'ส่วนหัก (Deduct)',
      '180': 'รวมรายได้',
      '190': 'รวมรายการหัก',
      '200': 'สุทธิ',
      '210': 'เงินสุทธิตามสกุลเงิน',
      '220': 'วัน',
      '230': 'ช.ม.',
      '240': 'อื่น ๆ',
      '250': 'รหัสรูปแบบ Pay Slip',
      '260': 'O.T ',
      '270': 'รายละเอียดอื่นๆ',
      '280': 'ยอดสะสม ประจำปี',
      '290': 'เริ่มจากพนักงาน',
      '300': 'จำนวนชม.',
      '310': 'บริษัท',
      '320': 'จำนวนเงิน',
      '330': 'กะกลางวัน',
      '340': 'กะกลางคืน',
      '350': 'วันหยุดประเพณี + Shutdown',
      '360': 'วันหยุดพิเศษ',
      '370': 'วันหยุดแลกเปลี่ยน',
      '380': 'วันหยุดพักร้อนบริษัท',
      '390': 'ฝ่าย',
      '400': 'แผนก/หน่วยงาน',
      '410': 'พิมพ์ Payslip',
      '420': 'Pay Slip',
      '430': 'ใบปะหน้า',
      '440': 'ลำดับที่',
      '450': 'รหัสพนักงาน',
      '460': 'ชื่อ-นามสกุล',
      '470': 'หน่วยงาน',
      '480': 'ตำแหน่ง',
      '490': 'ลายเซ็นต์',
      '500': 'กลุ่มการทำงาน',
      '510': 'วันที่จ่าย',
      '520': 'รายได้อื่นๆ',
      '530': 'ส่วนหักอื่นๆ',
      '540': 'เงินกองทุนสำรองฯสะสม(บริษัท)',
      '550': 'เงินกองทุนสำรองฯสะสม(พนง.)'
    },
    'HRPY55X0': {
      '10': 'งวดที่/เดือน/ปี',
      '20': 'รหัสพนักงาน หรือรหัสหน่วยงาน',
      '30': 'กลุ่มการจ่ายเงินเดือน',
      '40': 'เริ่มจากพนักงาน',
      '50': 'รหัสรูปแบบ Pay Slip',
      '60': 'ลำดับที่',
      '70': 'รหัสพนักงาน',
      '80': 'ชื่อ-นามสกุล',
      '90': 'หน่วยงาน',
      '100': 'กลุ่มการทำงาน',
      '110': 'ตำแหน่ง',
      '120': 'ลายเซ็นต์'
    },
    'HRPY55X1': {
      '10': 'รหัสรูปแบบ Pay Slip',
      '20': 'รูปแบบรายงาน',
      '30': 'รายละเอียดที่ต้องการแสดง',
      '40': 'ข้อมูลเงินสะสม',
      '50': 'ข้อมูลการปฎิบัติงาน',
      '60': 'รายได้สะสม',
      '70': 'ภาษีสะสม',
      '80': 'เงินสะสมกองทุนเลี้ยงชีพ',
      '90': 'เงินสะสมประกันสังคม',
      '100': 'เงินได้จ่ายนอกระบบ',
      '110': 'จำนวนวันทำงาน',
      '120': 'สิทธิพักร้อนคงเหลือ',
      '130': 'ชั่วโมง O.T. แยกตาม rate',
      '140': 'แสดง Rate O.T.',
      '150': '1.',
      '160': '2.',
      '170': '3.',
      '180': '4.',
      '190': '5.'
    },
    'HRPY55X2': {
      '5': 'รายได้',
      '10': 'ลำดับ',
      '20': 'รหัสรายได้',
      '30': 'รายละเอียด',
      '40': 'แสดง Label'
    },
    'HRPY55X3': {
      '5': 'ส่วนหัก',
      '10': 'ลำดับ',
      '20': 'รหัสส่วนหัก',
      '30': 'รายละเอียด',
      '40': 'แสดง Label'
    }
  },
  th: {
    'HRES81X': {
      '10': 'ใบแจ้งการจ่ายเงินได้',
      '20': 'รหัสพนักงาน',
      '30': 'สำหรับงวดที่',
      '40': 'เดือน/ปี'
    },
    'HRES81XC1': {
      '10': 'งวดที่',
      '15': 'เดือน / ปี',
      '20': 'รายละเอียดการจ่ายเงินเดือน',
      '25': 'เลขที่บัญชี',
      '30': 'วันที่จ่าย',
      '35': 'รายได้',
      '40': 'ส่วนหัก',
      '45': 'รวมรายได้',
      '50': 'สุทธิ',
      '55': 'เงินสุทธิตามสกุลเงิน',
      '60': 'รายได้สะสม',
      '65': 'เงินสะสมกองทุนสำรองเลี้ยงชีพ',
      '70': 'รวมค่าใช้จ่าย',
      '75': 'ภาษีสะสม',
      '80': 'เงินสะสมประกันสังคม'
    },
    'HRES81XCM': {
      '10': 'รหัสพนักงาน',
      '15': 'ตำแหน่งงาน',
      '16': 'แผนก',
      '17': 'ช่วงเวลาจ่ายเงินเดือน',
      '18': 'ช่วงระยะเวลาเช็คเวลาทำงาน',
      '19': 'ฐานเงินเดือน',
      '20': 'ชื่อ',
      '30': 'งวดที่',
      '40': 'เดือน',
      '50': 'ปี',
      '60': 'เลขที่บัญชี',
      '70': 'ธนาคาร',
      '80': 'วันที่จ่าย (Payment Date)',
      '90': 'รายได้ (Incomes)',
      '100': 'บาท',
      '110': 'ส่วนหัก (Deductions)',
      '120': 'บาท',
      '130': 'รายละเอียด อื่นๆ (Others)',
      '140': 'สิทธิพักร้อนคงเหลือ (VL)',
      '150': 'จำนวนวันทำงาน',
      '160': 'ยอดสะสมประจำปี (Yearly Sum)',
      '170': 'รายได้สะสม (Incomes)',
      '180': 'ภาษีสะสม (Tax)',
      '190': 'เงินสะสมกองทุน (PF)',
      '200': 'เงินประกันสังคมสะสม (SI)',
      '210': 'รวมรายได้ (Total Incomes)',
      '220': 'รวมเงินหัก (Total Deductions)',
      '230': 'จ่ายงวดนี้',
      '240': 'เงินได้สุทธิ (Net Receipt)',
      '245': 'อัตราค่าจ้าง (Salary)',
      '250': 'O.T',
      '260': 'ชม.',
      '270': 'วัน',
      '280': 'อื่น ๆ'
    },
    'HRPY55X': {
      '10': 'งวดที่',
      '20': 'เดือน',
      '30': 'ปี',
      '40': 'รหัสพนักงาน',
      '50': 'หรือรหัสหน่วยงาน',
      '60': 'กลุ่มการจ่ายเงินเดือน',
      '70': 'มาตรฐาน',
      '80': 'Preprinted form',
      '90': 'รูปแบบการพิมพ์',
      '100': 'แบบฟอร์ม Pay Slip',
      '110': 'รหัส',
      '120': 'รายละเอียดการจ่ายเงินเดือน',
      '130': 'ACC NO',
      '140': 'ธนาคาร',
      '150': 'วันที่จ่าย',
      '160': 'รายได้ (Income)',
      '170': 'ส่วนหัก (Deduct)',
      '180': 'รวมรายได้',
      '190': 'รวมรายการหัก',
      '200': 'สุทธิ',
      '210': 'เงินสุทธิตามสกุลเงิน',
      '220': 'วัน',
      '230': 'ช.ม.',
      '240': 'อื่น ๆ',
      '250': 'รหัสรูปแบบ Pay Slip',
      '260': 'O.T ',
      '270': 'รายละเอียดอื่นๆ',
      '280': 'ยอดสะสม ประจำปี',
      '290': 'เริ่มจากพนักงาน',
      '300': 'จำนวนชม.',
      '310': 'บริษัท',
      '320': 'จำนวนเงิน',
      '330': 'กะกลางวัน',
      '340': 'กะกลางคืน',
      '350': 'วันหยุดประเพณี + Shutdown',
      '360': 'วันหยุดพิเศษ',
      '370': 'วันหยุดแลกเปลี่ยน',
      '380': 'วันหยุดพักร้อนบริษัท',
      '390': 'ฝ่าย',
      '400': 'แผนก/หน่วยงาน',
      '410': 'พิมพ์ Payslip',
      '420': 'Pay Slip',
      '430': 'ใบปะหน้า',
      '440': 'ลำดับที่',
      '450': 'รหัสพนักงาน',
      '460': 'ชื่อ-นามสกุล',
      '470': 'หน่วยงาน',
      '480': 'ตำแหน่ง',
      '490': 'ลายเซ็นต์',
      '500': 'กลุ่มการทำงาน',
      '510': 'วันที่จ่าย',
      '520': 'รายได้อื่นๆ',
      '530': 'ส่วนหักอื่นๆ',
      '540': 'เงินกองทุนสำรองฯสะสม(บริษัท)',
      '550': 'เงินกองทุนสำรองฯสะสม(พนง.)'
    },
    'HRPY55X0': {
      '10': 'งวดที่/เดือน/ปี',
      '20': 'รหัสพนักงาน หรือรหัสหน่วยงาน',
      '30': 'กลุ่มการจ่ายเงินเดือน',
      '40': 'เริ่มจากพนักงาน',
      '50': 'รหัสรูปแบบ Pay Slip',
      '60': 'ลำดับที่',
      '70': 'รหัสพนักงาน',
      '80': 'ชื่อ-นามสกุล',
      '90': 'หน่วยงาน',
      '100': 'กลุ่มการทำงาน',
      '110': 'ตำแหน่ง',
      '120': 'ลายเซ็นต์'
    },
    'HRPY55X1': {
      '10': 'รหัสรูปแบบ Pay Slip',
      '20': 'รูปแบบรายงาน',
      '30': 'รายละเอียดที่ต้องการแสดง',
      '40': 'ข้อมูลเงินสะสม',
      '50': 'ข้อมูลการปฎิบัติงาน',
      '60': 'รายได้สะสม',
      '70': 'ภาษีสะสม',
      '80': 'เงินสะสมกองทุนเลี้ยงชีพ',
      '90': 'เงินสะสมประกันสังคม',
      '100': 'เงินได้จ่ายนอกระบบ',
      '110': 'จำนวนวันทำงาน',
      '120': 'สิทธิพักร้อนคงเหลือ',
      '130': 'ชั่วโมง O.T. แยกตาม rate',
      '140': 'แสดง Rate O.T.',
      '150': '1.',
      '160': '2.',
      '170': '3.',
      '180': '4.',
      '190': '5.'
    },
    'HRPY55X2': {
      '5': 'รายได้',
      '10': 'ลำดับ',
      '20': 'รหัสรายได้',
      '30': 'รายละเอียด',
      '40': 'แสดง Label'
    },
    'HRPY55X3': {
      '5': 'ส่วนหัก',
      '10': 'ลำดับ',
      '20': 'รหัสส่วนหัก',
      '30': 'รายละเอียด',
      '40': 'แสดง Label'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres81x.js